<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner"  title="Appointment" subtitle="Appointment" ></app-page-banner>
        <!-- FORM ONE SECTION END -->
      <div class="container pt-0 pb-5">       
        <div class="row align-items-center">
            <div class="col-md-12 card p-3">
                    <div class="row">
                    <div class="col-md-4">
                        <p class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                            </svg>
                            Patient Name: <span>{{ applicant_token?.first_name + ' ' + applicant_token?.last_name}}</span>
                        </p>
                    </div>
                    <div class="col-md-4">
                        <p class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                                <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0h-7zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492V2.5z"/>
                            </svg>
                            Patient Number: <span>{{applicant_token?.patient_number}}</span>
                        </p>
                    </div>
                    <div class="col-md-4">
                        <p class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                            Date of Birth: <span>{{applicant_token?.DOB | date:'dd/MM/yyyy'}}</span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <p class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327z"/>
                            </svg>
                            Country: <span>{{applicant_token?.country}}</span>
                        </p>
                    </div>
                    <div class="col-md-4">
                        <p class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
                                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                            </svg>
                            State: <span>{{applicant_token?.state}}</span>
                        </p>
                    </div>
                    <div class="col-md-4">
                        <p class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
                            </svg>
                            City: <span>{{applicant_token?.city}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-md-12">
                <div class="card appointment-card">
                    <div class="card-header main-header">
                        <h5>Book Your Appointment</h5>
                    </div>
                    <div class="card-body p-0 form-style-md">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="matt-group">
                                   <mat-label>User Role<b class="star">*</b></mat-label>
                                   <mat-form-field appearance="fill">
                                      <mat-select placeholder="Select User Role"  [(ngModel)]="user_role" (selectionChange)="getUser($event.value)">
                                         <mat-option *ngFor="let role of UserRole" [value]="role.id">{{role.name}}</mat-option> 
                                      </mat-select>
                                      <!-- <mat-error *ngIf="Error('user_role','required')">Select department</mat-error> -->
                                   </mat-form-field>
                                </div>
                             </div>
              
                             <div class="col-md-6">
                                <div class="matt-group">
                                   <mat-label>User<b class="star">*</b></mat-label>
                                   <mat-form-field appearance="fill">
                                         <mat-select placeholder="Select User"   [(ngModel)]="user_id" (selectionChange)="getUserCheck($event.value)">
                                         <mat-option *ngFor="let role of userLists" [value]="role.id">{{role.first_name+' '+role.last_name}}</mat-option> 
                                      </mat-select>
                                      <!-- <mat-error *ngIf="Error('user_role','required')">Select department</mat-error> -->
                                   </mat-form-field>
                                </div>
                             </div>
                        </div>
                        <div class="row g-0">
                            <div class="col-md-4 date-section">
                                <div class="section-header">
                                    <h6 class="text-center"><strong>Select Date</strong></h6>
                                </div>
                                <div class="calendar-wrapper">
                                    <mat-calendar [(selected)]="selectedDate" (selectedChange)="getSlots($event)"></mat-calendar>
                                </div>
                            </div>
                            <div class="col-md-8 slot-section">
                                <div class="section-header">
                                    <h6 class="text-center "><strong>Available Slots</strong></h6>
                                </div>
                                <div class="slots-wrapper">
                                    <div class="row g-3 p-3">
                                        <div class="col-md-4" *ngFor="let slot of availableSlots">
                                            <button mat-raised-button 
                                                    class="slot-button w-100"
                                                    [ngClass]="{
                                                        'btn-primary': selectedSlot === slot, 
                                                        'btn-outline-primary': !slot.disabled && !slot.booked && selectedSlot !== slot, 
                                                        'btn-secondary': slot.disabled && !slot.booked && !slot.isLunchSlot,
                                                        'booked-slot': slot.booked,
                                                        'lunch-slot': slot.isLunchSlot
                                                    }"
                                                    [attr.aria-disabled]="slot.disabled || slot.booked"
                                                    [disabled]="slot.disabled || slot.booked"
                                                    (click)="selectSlot(slot)">
                                              <div class="slot-content">
                                                <span class="time-slot">
                                                  {{slot.startTime}} - {{slot.endTime}}
                                                </span>
                                                <span class="slot-status" *ngIf="slot.booked">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock" viewBox="0 0 16 16">
                                                    <path d="M8 1a4 4 0 0 0-4 4v3H3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-1V5a4 4 0 0 0-4-4zm3 7V5a3 3 0 0 0-6 0v3h6z"/>
                                                  </svg>
                                                  <small>Reserved</small>
                                                </span>
                                                <span class="slot-status" *ngIf="slot.isLunchSlot">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cup-hot" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M.5 6a.5.5 0 0 0-.488.608l1.652 7.434A2.5 2.5 0 0 0 4.104 16h5.792a2.5 2.5 0 0 0 2.44-1.958l.131-.59a3 3 0 0 0 1.3-5.854l.221-.99A.5.5 0 0 0 13.5 6H.5ZM13 12.5a2.01 2.01 0 0 1-.316-.025l.867-3.898A2.001 2.001 0 0 1 13 12.5Z"/>
                                                    <path d="m4.4.8-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 3.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 3.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 3 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 4.4.8Zm3 0-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 6.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 6.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 6 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 7.4.8Zm3 0-.003.004-.014.019a4.077 4.077 0 0 0-.204.31 2.337 2.337 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 9.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 9.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 9 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 10.4.8Z"/>
                                                  </svg>
                                                  <small>Lunch Time</small>
                                                </span>
                                                <span class="slot-status past" *ngIf="slot.disabled && !slot.booked && !slot.isLunchSlot">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16">
                                                    <path d="M8 3.5a.5.5 0 0 1 .5.5v4.25l3.5 2.1a.5.5 0 0 1-.5.85l-4-2.4A.5.5 0 0 1 7.5 8V4a.5.5 0 0 1 .5-.5z"/>
                                                    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14z"/>
                                                  </svg>      
                                                  <small>Past</small>
                                                </span>
                                              </div>
                                            </button>
                                          </div>
                                    </div>
                                    <div class="slot-legend p-3" *ngIf="availableSlots && availableSlots.length > 0">
                                        <div class="d-flex justify-content-center">
                                            <div class="legend-item me-3">
                                                <span class="legend-color available"></span>
                                                <span class="legend-text">Available</span>
                                            </div>
                                            <div class="legend-item me-3">
                                                <span class="legend-color selected"></span>
                                                <span class="legend-text">Selected</span>
                                            </div>
                                            <div class="legend-item me-3">
                                                <span class="legend-color booked"></span>
                                                <span class="legend-text">Reserved</span>
                                            </div>
                                            <div class="legend-item me-3">
                                                <span class="legend-color lunch"></span>
                                                <span class="legend-text">Lunch Time</span>
                                            </div>
                                            <div class="legend-item">
                                                <span class="legend-color past"></span>
                                                <span class="legend-text">Past</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center p-4" *ngIf="availableSlots && availableSlots.length === 0">
                                        <p class="no-slots-message">No slots available for selected date</p>
                                    </div>
                                    <div class="text-center p-4" *ngIf="!availableSlots">
                                        <p class="no-slots-message">Please select a date and doctor to view available slots</p>
                                    </div>
                                    <!-- Confirm Button Section -->
                                    <div class="text-center p-4" *ngIf="selectedSlot">
                                        <button class="btn btn-success confirm-slot-btn" (click)="openConfirmModal()">
                                            Confirm Selected Time Slot
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
               

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>

<!-- Bootstrap Modal -->
<div class="modal fade" id="appointmentModal" tabindex="-1" aria-labelledby="appointmentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-gradient -">
                <div class="modal-header-content">
                   
                    <h5 class="modal-title text-white" id="appointmentModalLabel">Appointment Booking</h5>
                    <div class="patient-header-info">
                        <div class="patient-name">{{applicant_token?.first_name}} {{applicant_token?.last_name}}</div>
                        <div class="patient-number">Patient Number: {{applicant_token?.patient_number}}</div>
                    </div>
                </div>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <div class="patient-details-section">
                    <div class="details-grid">
                        <div class="detail-item">
                            <span class="detail-icon">📱</span>
                            <span class="detail-label">Mobile</span>
                            <span class="detail-value">{{applicant_token?.mobile}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-icon">🎂</span>
                            <span class="detail-label">DOB</span>
                            <span class="detail-value">{{applicant_token?.DOB | date:'dd/MM/yyyy'}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-icon">🌍</span>
                            <span class="detail-label">Country</span>
                            <span class="detail-value">{{applicant_token?.country}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-icon">📍</span>
                            <span class="detail-label">Location</span>
                            <span class="detail-value">{{applicant_token?.city}}, {{applicant_token?.state}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-icon">👨‍⚕️</span>
                            <span class="detail-label">Doctor Role</span>
                            <span class="detail-value">{{DoctorRole?.name}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-icon">👨‍⚕️</span>
                            <span class="detail-label">Doctor</span>
                            <span class="detail-value">{{Doctor?.first_name}} {{Doctor?.last_name}}</span>
                        </div>
                    </div>
                </div>
                <div class="info-row">
                    <span class="info-label">📅 Booking date</span>
                    <span class="info-value">{{selectedDate | date:'EEEE, MMMM d'}}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">⏰ Booking slot</span>
                    <span class="info-value">{{selectedSlot?.startTime}} - {{selectedSlot?.endTime}}</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-success" *ngIf="!isLoading" (click)="confirmAppointment()">Confirm</button>
                <button type="button" class="btn btn-success" *ngIf="isLoading" disabled>Confirming...</button>
            </div>
        </div>
    </div>
</div>

<style>
.slot-button.booked-slot {
    background-color: rgba(255, 220, 220, 0.2) !important;
    border: 1px solid #ffcccc !important;
    color: #dc3545 !important;
    cursor: not-allowed;
}
</style>